import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { initialUserProfile } from '../constants/initialStates';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [authUser, setAuthUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [userProfile, setUserProfile] = useState(initialUserProfile);
  const [toastMessage, setToastMessage] = useState(null);

  useEffect(() => {
    let unSubUser;
    
    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      setAuthUser(user);
      if (user) {
        unSubUser = onSnapshot(doc(db, 'users', user.uid), async (docSnap) => {
          if (docSnap.exists()) {
            setUserProfile(docSnap.data());
          } else {
             const newUserProfile = { 
                 ...initialUserProfile, 
                 email: user.email,
                 resilience_profile: {
                     persistence_score: 0,
                     highest_tier_completed: 'none',
                     failed_brutalist_attempts: 0,
                     frustration_index: 0.0
                 }
             };
             setDoc(doc(db, 'users', user.uid), newUserProfile);
          }
          setAuthLoading(false);
        });
      } else {
        setUserProfile(initialUserProfile);
        setAuthLoading(false);
      }
    });

    return () => {
      unsubscribeAuth();
      if (unSubUser) unSubUser();
    };
  }, []);

  return (
    <AuthContext.Provider value={{
      authUser, authLoading, 
      userProfile, setUserProfile,
      toastMessage, setToastMessage
    }}>
      {children}
    </AuthContext.Provider>
  );
};